import { render, staticRenderFns } from "./PlantCreate.vue?vue&type=template&id=17a0a4ea&scoped=true"
import script from "./PlantCreate.vue?vue&type=script&lang=ts"
export * from "./PlantCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a0a4ea",
  null
  
)

export default component.exports